import { IconButton, Typography } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import StopIcon from "@mui/icons-material/Stop";
import { useEffect, useRef, useState } from "react";
import { TrackProps } from "./types";
import WaveSurfer from "wavesurfer.js";
import { Spinner } from "reactstrap";
import { TrackContainer, TrackContent, TrackImage } from "./styles";
import { TrackMetadata, WaveformContainer, trackStyles } from "./styles";
import { APP_COLOR, FONT_FAMILY, TEXT_COLOR } from "../../theme";

const Track: React.FC<TrackProps> = ({
  track,
  setAudioTrack,
  handlePlay,
  handleStop,
}) => {
  const { id, image, title, subtitle, genre, audio, isPlaying, waveSurfer } =
    track;
  const ref = useRef<HTMLDivElement | null>(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (ref.current && !waveSurfer) {
      const audioTrack = WaveSurfer.create({
        container: ref.current,
        responsive: true,
        cursorWidth: 0,
        barWidth: 4,
        barRadius: 5,
        progressColor: APP_COLOR,
      });
      audio && audioTrack.load(audio);
      audioTrack.on("ready", function () {
        setLoaded(true);
      });
      setAudioTrack(id, audioTrack);
    }
  }, [audio, id, setAudioTrack, waveSurfer]);

  useEffect(() => {
    return () => {
      waveSurfer?.stop();
    };
  }, [waveSurfer]);

  return (
    <TrackContainer>
      <TrackImage
        src={
          image && image?.includes("http")
            ? image
            : `/assets/images/logo512.png`
        }
        alt=""
      />
      <TrackContent>
        <TrackMetadata>
          <IconButton
            aria-label="play"
            size="small"
            onClick={() => handlePlay(id)}
            sx={{ padding: 0.5 }}
          >
            {isPlaying ? (
              <PauseIcon sx={{ height: 25, width: 25 }} />
            ) : (
              <PlayArrowIcon sx={{ height: 25, width: 25 }} />
            )}
          </IconButton>

          <IconButton
            aria-label="stop"
            size="small"
            onClick={() => handleStop(id)}
            sx={{ padding: 0.5 }}
          >
            <StopIcon sx={{ height: 25, width: 25 }} />
          </IconButton>
          <div style={{ flexGrow: 1, marginLeft: 5, color: TEXT_COLOR }}>
            <Typography sx={trackStyles.title}>{title}</Typography>
            <Typography sx={{ fontFamily: FONT_FAMILY, fontSize: 12 }}>
              {subtitle}
            </Typography>
          </div>
          <div style={{ display: "flex", color: TEXT_COLOR }}>
            <Typography sx={trackStyles.genreLabel}>Genre</Typography>
            <Typography sx={trackStyles.genre}>{genre}</Typography>
          </div>
        </TrackMetadata>
        <WaveformContainer>
          <div style={{ minWidth: "100%" }} ref={ref}>
            {!loaded && (
              <Spinner style={{ marginTop: 10, marginLeft: 10 }} color="info" />
            )}
            {loaded && <div style={{ minWidth: "100%" }} ref={ref}></div>}
          </div>
        </WaveformContainer>
      </TrackContent>
    </TrackContainer>
  );
};

export default Track;
